import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { Button, Card, CardContent, Grid, Box, Typography, TextField, MenuItem, CircularProgress, Chip, IconButton, Paper, Tabs, Tab } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { ArrowBack, Download, Search, Clear } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TaxReport from './CustomerBooking/TaxReport';
import SumarryList from './ExpertWalletSummary/SumarryList';
import ExpertPayout from '../ExpertPayout/ExpertPayout';
import PlatformTaxDetail from './ExpertPlatform/PlatformTaxDetail';

const TaxReportIndex = () => {
    const menuDispatch = useDispatch();
    const navigate = useNavigate();
    const [tabValue,setTabValue] = useState(0);

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'tax-report'
        });
    }, []); 

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <PageHeaderLayout headerTitle={'Tax Report'}>
                <Button variant='contained' onClick={() => navigate(-1)} size='small' endIcon={<ArrowBack />}>
                    Back
                </Button>
            </PageHeaderLayout>
            <Box sx={{ }}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Paper sx={{}}>
                            <Tabs
                                value={tabValue}
                                onChange={(event, newValue) => {
                                setTabValue(newValue);
                                }}
                                textColor='primary'
                                indicatorColor='primary'
                                // variant='fullWidth'
                                sx={{ width: "100%" ,minHeight:0 }}
                            >
                                <Tab label="Customer" sx={{fontSize:'.8rem',minHeight:0, padding:'1%',textTransform:'capitalize'}}/>
                                <Tab label="Expert Wallet" sx={{fontSize:'.8rem',minHeight:0, padding:'1%',textTransform:'capitalize'}}/>
                                <Tab label="Expert Platform" sx={{fontSize:'.8rem',minHeight:0, padding:'1%',textTransform:'capitalize'}}/>
                            </Tabs>
                        </Paper>
                        <Grid item xs={12}>
                            <Box sx={{minHeight:400,mt:'.5%'}} >
                                {tabValue === 0 && <TaxReport />}
                                {/* {tabValue === 1 && <ExpertWalletTaxReport/>} */}
                                {tabValue === 1 && <SumarryList/>}
                                {tabValue === 2 && <PlatformTaxDetail />}

                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Box> 
        </LocalizationProvider>
    );
};

export default TaxReportIndex;
